export default __webpack_public_path__ + "static/media/item-rating-gold.93d58b99.svg";